import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { sbaAxios } from "../../../utils/sbaAxios";
import {
  getAllFamilies,
  getFamilyMapping,
  getFamilyEntitiesToAdd,
  insertUpdateFamily,
  insertFamilyMapping,
  deleteFamily,
  deleteFamilyMapping,
  getClientStatementAPI,
  getCSByIDAPI,
  getLinkedPortfolioAPI,
  insertUpdateCSAPI,
  getReviewersAPI,
  getFrequnecyAPI,
  getbatchAPI,
  deleteCSAPI,
  deleteCSPortfolioAPI,
  getEntitesCSAPI,
  saveCSLinkedPortfolio,
  getClientStatementUnMappedAccountContact
} from "../../../../config/apiConfig";
import { AgGridReact } from "ag-grid-react";
import { SBAComboBox, SBADropDown } from "../../../UiComponents/SBADropDown";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { Modal } from "react-bootstrap";
import { SBNotify } from "../../../utils/sbNotify";
import { ToastContainer } from "react-toastify";
import moment from "moment";
import { SBADrawer } from "../../../UiComponents/SBADrawer";
import { SBDatePicker } from "../../../UiComponents/SBDatePicker";
import { getContacts } from "../../../../config/apiConfig";
import { getTaxEntityListAPI } from "../../../../config/apiConfig";


export const Admin = () => {
  const [selectedContactInfoButton, setContactInfoButton] = useState(1);
  useEffect(()=>{
    document.title = `Client Statements`;
  },[])
  const buttonNames = [
    { buttonIds: 1, name: "Family" },
    { buttonIds: 2, name: "Client Statement" },
  ];

  const contactInfoButtonClick = (buttonId) => {
    setContactInfoButton(buttonId);
  };

  let componentToRender;

  switch (selectedContactInfoButton) {
    case 1:
      componentToRender = <FamilyComponent />;
      break;
    case 2:
      componentToRender = <ClientStatementComponent />;
      break;
    default:
      componentToRender = null;
  }

  const ContactInfoButtons = buttonNames.map((button, index) => (
    <button
      key={index}
      id={`button-${button.buttonIds}`}
      className={`non-gappable-button ${selectedContactInfoButton === button.buttonIds
          ? "selected-non-gappable-button"
          : ""
        }`}
      onClick={() => contactInfoButtonClick(button.buttonIds)}
    >
      {button.name}
    </button>
  ));

  return (
    <div id="contacts" className="mainContentData">
      <div className="container-fluid">
        <div className="justify-content-between align-items-center">
          <div className="button-container">{ContactInfoButtons}</div>
          <div className="mt-3">{componentToRender}</div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};
const FamilyComponent = () => {
  const emptyConfig = {
    FamilyAdd: "0",
    Family: "Family",
    Portfolio: "Portfolio",
    ClientStatement: "Client Statement",
    Save: "Save",
    Update: "Update",
    Yes: "Yes",
  };
  const emptyState = {
    FamilyName: "",
    EntityName: "",
  };
  const Gstate = useSelector(state => state);
  const isEditable = Gstate.authorizationData.isEditable;
  const [gridApi, setGridApi] = useState(null);
  const [familyRowData, setFamilyData] = useState(null);
  const [familieId, setFamilyId] = useState("");
  const [portfolioRowData, setPortfolioData] = useState(null);
  const [csRowData, setCSData] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [buttonName, setButtonName] = useState(null);
  const [title, setTitle] = useState(null);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [newName, setNewName] = useState(emptyState);
  const [dropDownData, setDropDownData] = useState([]);
  const [dropDownValue, setDropDownValue] = useState({
    EntityName: "",
    EntityId: 0,
  });

  const familiesData = async () => {
    try {
      const response = await sbaAxios({
        url: `${getAllFamilies}`,
        method: "get",
      });
      setFamilyData(response);
    } catch (error) {
      console.error("Error fetching family data:", error);
    }
  };

  const portfolioandCsData = async (familyId) => {
    try {
      const response = await sbaAxios({
        url: `${getFamilyMapping}${familyId}`,
        method: "get",
      });
      const portfolioData = response.filter((item) => item.EntityTypeId === 2);
      const csData = response.filter((item) => item.EntityTypeId === 51);
      setPortfolioData(portfolioData);
      setCSData(csData);
    } catch (error) {
      console.error("Error fetching portfolio and CS data:", error);
    }
  };

  const GetFamilyEntitiesToAdd = async (EntityTypeId, SearchValue) => {
    try {
      if (SearchValue !== null || SearchValue !== "") {
        const response = await sbaAxios({
          url: `${getFamilyEntitiesToAdd}${selectedItem?.FamilyId},${EntityTypeId},${SearchValue}`,
          method: "get",
        });
        setDropDownData(response);
      } else {
        SBNotify({ type: "error", Msg: "Please Enter Search String" });
      }
    } catch (error) {
      console.error("Error fetching Portfolio data:", error);
      setDropDownData([]);
    }
  };

  const InsertUpdateFamily = async () => {
    if (!newName?.FamilyName) {
      SBNotify({
        type: "error",
        Msg: "Family Name is required.",
      });
      return;
    }
    const familyId = familieId === "" ? selectedItem.FamilyId : 0;
    const Message = familieId === "" ? "Updated Successfully" : "Saved Successfully";
    const data = {
      familyId: familyId,
      familyName: newName?.FamilyName,
      modifiedBy: 0,
    };

    sbaAxios({
      url: `${insertUpdateFamily}`,
      method: "post",
      data: data,
    })
      .then((response) => {
        if (response) {
          closeModal();
            familiesData();
            portfolioandCsData(response);
          SBNotify({
            type: "success",
            Msg: `${newName?.FamilyName} ${Message}`,
          });
        } else {
          closeModal();
          SBNotify({
            type: "error",
            Msg: `${newName?.FamilyName} Failed to Update`,
          });
        }
      })
      .catch(() => { });
  };

  const InsertFamilyMapping = async () => {
    if (!dropDownValue?.EntityId) {
      SBNotify({
        type: "error",
        Msg: `${title} Name is required.`,
      });
      return;
    }
    const data = {
      familyId: selectedItem.FamilyId,
      EntityTypeId: title === "Portfolio" ? 2 : 51,
      entityId: dropDownValue.EntityId,
    };

    sbaAxios({
      url: `${insertFamilyMapping}${data.familyId},${data.EntityTypeId},${data.entityId}`,
      method: "post",
    })
      .then((response) => {
        if (response) {
          closeModal();
          portfolioandCsData(data.familyId);
          SBNotify({
            type: "success",
            Msg: `${dropDownValue?.EntityName} Inserted Successfully`,
          });
        } else {
          closeModal();
          SBNotify({
            type: "error",
            Msg: `${dropDownValue?.EntityName} Failed to Update`,
          });
        }
      })
      .catch(() => { });
  };

  const DeleteFamilyMapping = async () => {
    sbaAxios({
      url: `${deleteFamilyMapping}${selectedItem.FamilyMappingId}`,
      method: "post",
    })
      .then((response) => {
        if (response) {
          closeModal();
          portfolioandCsData(selectedItem.FamilyId);
          SBNotify({
            type: "success",
            Msg: "Deleted Successfully,",
          });
        } else {
          closeModal();
          portfolioandCsData(selectedItem.FamilyId);
          SBNotify({ type: "error", Msg: "Failed" });
        }
      })
      .catch(() => { });
  };

  const DeleteFamily = async () => {
    sbaAxios({
      url: `${deleteFamily}${selectedItem.FamilyId}`,
      method: "post",
    })
      .then((response) => {
        if (response) {
          closeModal();
          familiesData();
          SBNotify({
            type: "success",
            Msg: "Deleted Successfully",
          });
        } else {
          closeModal();
          SBNotify({ type: "error", Msg: "Failed" });
        }
      })
      .catch(() => { });
  };

  useEffect(() => {
    familiesData();
  }, []);

  const onGridReady = (params) => {
    setGridApi(params.api);
    params.api.sizeColumnsToFit();
    };   
    

    const rowDataUpdated = (params) => {
        params.api.forEachNodeAfterFilter((node, index) => {
            if (index === 0) {
                node.setSelected(true);
                const data = node.data;
                setSelectedItem(data);
            }
        });      
        params.api.addEventListener('filterChanged', () => {     
            if (!params.api.isAnyFilterPresent()) {            
                const firstNode = params.api.getDisplayedRowAtIndex(0);
                if (firstNode) {
                    firstNode.setSelected(true);
                    const data = firstNode.data;
                    setSelectedItem(data);
                }
            }
        });
    }

   
  useEffect(() => {
    if (selectedItem !== null) {
      portfolioandCsData(selectedItem.FamilyId);
    }
  }, [selectedItem]);

  const onAddNewClick = (addTitle) => {
    if (isEditable === true) {
      setTitle(addTitle);
      setDropDownValue();
      setDropDownData([]);
      setButtonName(emptyConfig.Save);
      setEditModal(true);
    }
  };

  const onFamilyGridRowClicked = (params) => {
    const familyId = params.data.FamilyId;
    setSelectedItem(params.data);
    portfolioandCsData(familyId);
  };

  const onEditClick = (params, newTitle) => {
    if (isEditable === true) {
      setTitle(emptyConfig.Family);
      setEditModal(true);
      setButtonName(newTitle !== emptyConfig.FamilyAdd ? emptyConfig.Update : emptyConfig.Save);
      if (newTitle !== emptyConfig.FamilyAdd) {
        setFamilyId("");
        setSelectedItem(params.data);
        setNewName(params.data);
      }
      else {
        setFamilyId(0);
      }
    }
  };

  const onDeleteClick = (params, newTitle) => {
    if (isEditable === true) {
      setTitle(newTitle);
      setSelectedItem(params.data);
      setDeleteModal(true);
      setButtonName(emptyConfig.Yes);
    }
  };

  const ActionsRenderer = ({ onEditClick, onDeleteClick }) => {
    const isEditable = useSelector(state => state.authorizationData.isEditable);
    return (
      <div className="actions-cell">
        <i
          className="fas fa-edit"
          style={{ color: isEditable ? "#47A547" : "", margin: "0 8px", cursor: "pointer" }}
          onClick={onEditClick}
        ></i>
        <i
          className="fas fa-trash"
          style={{ color: isEditable ? "#DF001B" : "", margin: "0 8px", cursor: "pointer" }}
          onClick={onDeleteClick}
        ></i>
      </div>
    );
  };

  const DeleteActionsRenderer = ({ onDeleteClick }) => {
    const isEditable = useSelector(state => state.authorizationData.isEditable);
    return (
      <div className="actions-cell">
        <i
          className="fas fa-trash"
          style={{ color: isEditable ? "#DF001B" : "", margin: "0 8px", cursor: "pointer" }}
          onClick={onDeleteClick}
        ></i>
      </div>
    );
  };

  const editNameChange = (e) => {
    setNewName({ ...newName, [e.target.name]: e.target.value });
  };

  const onDropDownFilterChange = (e) => {
    const EntityTypeId = title === emptyConfig.Portfolio ? 2 : 51;
    const SearchValue = e?.filter?.value || null;
    GetFamilyEntitiesToAdd(EntityTypeId, SearchValue);
  };

  const onDropDownChange = async (e) => {
    setDropDownValue(e.target.value);
  };

  const confirmUpdate = () => {
    if (title === emptyConfig.Family) {
      InsertUpdateFamily();
    } else {
      InsertFamilyMapping();
    }
  };

  const confirmDelete = () => {
    if (title === emptyConfig.Portfolio || title === emptyConfig.ClientStatement) {
      DeleteFamilyMapping();
    } else {
      DeleteFamily();
    }
  };

  const closeModal = () => {
    setEditModal(false);
    setDeleteModal(false);
    setNewName(null);
  };

  const familyColDef = [
    {
      headerName: "Family Name",
      field: "FamilyName",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Action",
      field: "",
      maxWidth: 100,
      cellRenderer: (params) => (
        <ActionsRenderer
          onEditClick={() => onEditClick(params, emptyConfig.Family)}
          onDeleteClick={() => onDeleteClick(params, emptyConfig.Family)}
        />
      ),
    },
  ];

  const portfolioColDef = [
    {
      headerName: "Portfolio Name",
      field: "EntityName",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Action",
      field: "",
      maxWidth: 100,
      cellRenderer: (params) => (
        <DeleteActionsRenderer
          onDeleteClick={() => onDeleteClick(params, emptyConfig.Portfolio)}
        />
      ),
    },
  ];

  const csColDef = [
    {
      headerName: "Client Statement",
      field: "EntityName",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Action",
      field: "",
      maxWidth: 100,
      cellRenderer: (params) => (
        <DeleteActionsRenderer
          onDeleteClick={() => onDeleteClick(params, emptyConfig.Portfolio)}
        />
      ),
    },
  ];

    const defaultColDef = {
        sortable: true, filter: true, floatingFilter: true, filter: 'agTextColumnFilter', suppressMovable: true,
        flex: 1,resizable:true
    };

  return (
    <>
      <div className="row flex-wrap">
        <div className="col-md-4">
          <div className="header-container m-2 fs-12">
            <b>Family:</b>
            <button
              className="p-sm-btn mx-1"
              onClick={() => onEditClick({
                data: {
                  "FamilyId": 0,
                  "FamilyName": "",
                  "ModifiedBy": 0
                }
              }, emptyConfig.FamilyAdd)}
              disabled={!isEditable}
            >
              <i className="fa-solid fa-plus" /> Add
            </button>
          </div>
          <div className="ag-theme-alpine m-1 " style={{ height: 600 }}>
            <AgGridReact
              columnDefs={familyColDef}
              defaultColDef={defaultColDef}
              rowData={familyRowData}
              onGridReady={onGridReady}
              rowSelection="single"
                          suppressRowClickSelection={false}
                          onRowDataUpdated={rowDataUpdated}
              onRowClicked={onFamilyGridRowClicked}
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="header-container m-2 fs-12">
            <b>Portfolio:</b>
            <button
              className="p-sm-btn mx-1"
              onClick={() => onAddNewClick(emptyConfig.Portfolio)}
              disabled={!isEditable}
            >
              <i className="fa-solid fa-plus" /> Add
            </button>
          </div>
          <div className="ag-theme-alpine m-1 " style={{ height: 600 }}>
            <AgGridReact
              columnDefs={portfolioColDef}
              defaultColDef={defaultColDef}
              rowData={portfolioRowData}
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="header-container m-2 fs-12">
            <b>Client Statement:</b>
            <button
              className="p-sm-btn mx-1"
              onClick={() => onAddNewClick(emptyConfig.ClientStatement)}
              disabled={!isEditable}
            >
              <i className="fa-solid fa-plus" /> Add
            </button>
          </div>
          <div className="ag-theme-alpine m-1 " style={{ height: 600 }}>
            <AgGridReact
              columnDefs={csColDef}
              defaultColDef={defaultColDef}
              rowData={csRowData}
            />
          </div>
        </div>
      </div>

      {
        <Modal show={deleteModal} onHide={closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Do you want to delete the {title}?</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Are you sure? you want to delete{" "}
              {selectedItem?.EntityName || selectedItem?.FamilyName}{" "}
              permanently.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <button className="s-sm-btn mx-1" onClick={closeModal}>
              Cancel
            </button>
            <button className="p-sm-btn mx-1" onClick={confirmDelete}>
              {buttonName}
            </button>
          </Modal.Footer>
        </Modal>
      }

      {
        <Modal show={editModal} onHide={closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Insert / Update {title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {title !== emptyConfig.Portfolio && title !== emptyConfig.ClientStatement ? (
              <>
                <label className="header-container m-1">
                  <b>{title} Name</b>
                </label>
                <div>
                  <input
                    className="form-control w-65"
                    type="text"
                    name="FamilyName"
                    value={newName?.FamilyName}
                    onChange={(e) => editNameChange(e)}
                  />
                </div>
              </>
            ) : (
              <>
                <label className="header-container m-1">
                  <b>{title}</b>
                </label>
                <div>
                  <SBAComboBox
                    placeholder="Please Enter value"
                    data={dropDownData || []}
                    value={dropDownValue}
                    onFilterChange={(e) => onDropDownFilterChange(e)}
                    onChange={(e) => onDropDownChange(e)}
                    textField={"EntityName"}
                    valueField={"EntityId"}
                    popupSettings={{ className: "modalDD" }}
                  />
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button className="s-sm-btn mx-1" onClick={closeModal}>
              Cancel
            </button>
            <button className="p-sm-btn mx-1" onClick={confirmUpdate}>
              {buttonName}
            </button>
          </Modal.Footer>
        </Modal>
      }
    </>
  );
};

const ClientStatementComponent = () => {
  const [CSData, setCSData] = useState([]);
  const [operation,setOperation]=useState('Add');
  const [showDrawer,setShowDrawer]=useState(false);
  const [portfolioDrawer,setPortfolioDrawer]=useState(false);
  const [selectedCS,setSelectedCS]=useState(null);
  const [linkedPortfolio,setLinkedPortfolio]=useState([]);
  const [deleteClientStatmentModal,setDeletClientStatementModal]=useState(false);
  const [deletePortfolioModal,setDeletePortfolioModal]=useState(false);
  const [selectedPortfolio,setSelectedPortfolio]=useState(false);
  const [render,setRender]=useState(false);
  const [updatePortfolioGrid,setUpdatePortfolioGrid]=useState(false);
  useEffect(() => {
    getClientStatementData();
  }, [render]);
  useEffect(()=>{
    if(selectedCS?.ClientStatementId)
    {
      getLinkedPortfolioByID(selectedCS?.ClientStatementId);
    }
    else {
      setLinkedPortfolio([]);
    }
  },[updatePortfolioGrid])
  const getClientStatementData = () => {
    sbaAxios({ url: getClientStatementAPI }).then(res => {
      setCSData(res);

    }).catch(e => {
      console.log(e, 'Error Loading the Client Statement Data');
      setCSData([]);
    })
  };

  const defaultColDef = {
    sortable: true, filter: true, floatingFilter: true, filter: 'agTextColumnFilter', suppressMovable: true,
    flex: 1,resizable:true
  };
  const editClientSatement=(CSid)=>{
    getSelectedCS(CSid);
    setShowDrawer(true);
    setOperation('Update');
  };
  const deleteClientStatement=(CSid)=>{
    setDeletClientStatementModal(true)
  }
  const ActionRenderer = (props) => {
    const CSid=props.data.ClientStatementId
    return <> <div className="actions-cell">
      <i className="fas fa-edit" style={{ color: true ? "#47A547" : "grey", margin: "0 8px", cursor: "pointer" }} onClick={(e) => { editClientSatement(CSid)}}></i>
      <i className="fa fa-trash" style={{ color: true ? "red" : "grey", margin: "0 8px", cursor: "pointer" }} onClick={(e) => { deleteClientStatement(CSid)}}></i>
    </div></>
  }
  const csColDef = [
    {
      headerName: "Client Statement Name",
      field: "ClientStatementName",
      filter: "agTextColumnFilter",
      minWidth:200,
      tooltipField: 'ClientStatementName' 
    },
    {
      headerName: "Start Date",
      field: "ClientStartDate",
      filter: "agTextColumnFilter",
      valueFormatter: getDateString
    },
    {
      headerName: "Frequency",
      field: "FrequencyName",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Batch",
      field: "BatchNumName",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Reviewer",
      field: "ReviewerName",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Internal",
      field: "InternalOnly",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "InComposite",
      field: "IncludeInComposite",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Do Not Automate",
      field: "DoNotAutomate",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Action",
      field: "",
      floatingFilter: false,
      cellRenderer: ActionRenderer,
      maxWidth:100
    }
  ];
  const LinkedPortfolioActionRenderer=(props)=>{
    const portfolio=props.data;
    return <> <div className="actions-cell">
      <i className="fa fa-trash" style={{ color: true ? "red" : "grey", margin: "0 8px", cursor: "pointer" }} onClick={(e) => { deletePortfolio(portfolio)}}></i>
    </div></>
  };
  const deletePortfolio=(data)=>{
    setDeletePortfolioModal(true);
    setSelectedPortfolio(data);
  };
  const linkedPortfolioColDef = [
    {
      headerName: "Portfolio Name",
      field: "EntityName",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Action",
      field: "",
      flex:0.3,
      floatingFilter: false,
      cellRenderer: LinkedPortfolioActionRenderer
    }
  ];
  const getSelectedCS=(CSid)=>{
    sbaAxios({url:`${getCSByIDAPI}${CSid}`}).then(res=>{
      setSelectedCS(res[0]);  
      getLinkedPortfolioByID(CSid)
      }).catch(e=>{
        console.log(e,'Error While retriving the data');
        setSelectedCS(null);
      });
     
  };
  const getLinkedPortfolioByID=(csID)=>{
    sbaAxios({url:`${getLinkedPortfolioAPI}${csID}`}).then(res=>{
      setLinkedPortfolio(res);
    }).catch(e=>{
      console.log(e,'Error while loading the Linked portfolio ');
      setLinkedPortfolio([])
    })
  };
  
  return <>
  <div className="row">
    <div className="col-md-8">
      <div className="header-container m-2 fs-12">
        <b>Client Statement:</b>
        <button
          className="p-sm-btn mx-1"
          onClick={() => {  setOperation('Add');setShowDrawer(true)}}
          disabled={false}
        >
          <i className="fa-solid fa-plus" /> Add
        </button>
      </div>
      <div className="ag-theme-alpine m-1 " style={{ height: 600 }}>
        <AgGridReact
          columnDefs={csColDef}
          defaultColDef={defaultColDef}
          rowData={CSData}
          onRowClicked={(e)=>{getSelectedCS(e.data.ClientStatementId)}}
          rowSelection="single"
          tooltipShowDelay={0}
          tooltipHideDelay={2000}
          enableBrowserTooltips={true}
          tooltipInteraction={true}
        />
      </div>
    </div>
    <div className="col-md-4">
      <div className="header-container m-2 fs-12">
        <b> Portfolio :</b>
        <button
          className="p-sm-btn mx-1"
          onClick={() => {setPortfolioDrawer(true)}}
          disabled={selectedCS===null}
        >
          <i className="fa-solid fa-plus" /> Add
        </button>
      </div>
      <div className="ag-theme-alpine m-1 " style={{ height: 600 }}>
        <AgGridReact
          columnDefs={linkedPortfolioColDef}
          defaultColDef={defaultColDef}
          rowData={linkedPortfolio}
        />
      </div>
    </div>
    </div>
    <SBADrawer open={showDrawer} setOpen={setShowDrawer} title={operation === "Add" ? 'Add Client Statement' : 'Update Client Statement'} >
      <ClientStatementEditor setRender={setRender} ClientStatement={operation === "Add" ? nulledCS : selectedCS} operation={operation} setDrawer={setShowDrawer}></ClientStatementEditor>
    </SBADrawer>
    <SBADrawer open={portfolioDrawer} setOpen={setPortfolioDrawer} title={'Add Portfolio'} >
      <PortfolioEditor ClientStatement={selectedCS} setRender={setUpdatePortfolioGrid}  operation={operation} setDrawer={setPortfolioDrawer}></PortfolioEditor>
    </SBADrawer>
    <ClientStatementDeleteModal setCS={setSelectedCS}  setRender={setRender} showModal={deleteClientStatmentModal} linkedPortfolio={linkedPortfolio} closeModal={setDeletClientStatementModal} clientStatement={selectedCS} setUpdatePortfolioGrid={setUpdatePortfolioGrid}/>
    <PortfolioDeleteModal   setRender={setUpdatePortfolioGrid} showModal={deletePortfolioModal} closeModal={setDeletePortfolioModal} Portfolio={selectedPortfolio}  ></PortfolioDeleteModal>
  </>;
};
const ClientStatementEditor = ({ ClientStatement, operation , setDrawer ,setRender }) => {
 
  
  const [cs,setCS]=useState(ClientStatement);
  const [frequencyDs,setFrequencyDs]=useState([]);
  const [batchDs,setBatchDs]=useState([]);
  const [reviewerDs,setReviewerDs]=useState([]);
  const [accountList,setAccountList]=useState([]);
  const [contactList,setContactList]=useState([]);

  useEffect(()=>{
    getDropDownData(getFrequnecyAPI,setFrequencyDs);
    getDropDownData(getbatchAPI,setBatchDs);
    getDropDownData(getReviewersAPI,setReviewerDs);
    
    getDropDownData(getReviewersAPI,setReviewerDs);
  },[]);

  const getDropDownData=async(method,setState)=>{ 
    setState(await sbaAxios({url:method})); 
  };

  const getUnMappedContacts=async(method,setState,option1)=>{ 
    const Data=await sbaAxios({url:method});
    if (option1?.EntityId == 0 || option1?.EntityId == -1)
      setState([...Data.filter(item => item.EntityTypeId == 2)]);
    else
      setState([option1, ...Data.filter(item => item.EntityTypeId == 2)]);

  };
  const getUnMappedAccounts=async(method,setState,option1)=>{ 
    const Data=await sbaAxios({url:method});
    if(option1?.EntityId==0 || option1?.EntityId==-1 )
      setState( [...Data.filter(item=>item.EntityTypeId==1)]); 
    else 
    setState( [option1,...Data.filter(item=>item.EntityTypeId==1)]); 

  };
  
  useEffect(()=>{
    setCS(val=>ClientStatement);
    getUnMappedContacts(getClientStatementUnMappedAccountContact,setContactList ,{EntityId:ClientStatement?.ContactId,EntityName:ClientStatement?.ContactName});
    getUnMappedAccounts(getClientStatementUnMappedAccountContact,setAccountList ,{EntityId:ClientStatement?.TaxEntityId,EntityName:ClientStatement?.TaxEntityName});
  },[ClientStatement]);

  const updateOrInsertCS=()=>{
    const data={
      "clientStatementId": cs?.ClientStatementId ||  null,
      "clientStatementName": cs?.ClientStatementName,
      "clientStartDate": cs?.ClientStartDate,
      "frequencyId": cs?.FrequencyId,
      "frequencyName": cs?.FrequencyName,
      "batchNumId": cs?.BatchNumId,
      "batchNumName": cs?.BatchNumName,
      "reviewerId": cs?.ReviewerId,
      "reviewerName": cs?.ReviewerName,
      "internalOnly": cs?.InternalOnly ||false,
      "includeInComposite": cs?.IncludeInComposite ||  false,
      "doNotAutomate": cs?.DoNotAutomate || false ,
      "notes": cs?.Notes ||  "",
      "taxEntityId": cs?.TaxEntityId || 0,
      "taxEntityName": "",
      "contactId": cs?.ContactId || 0,
      "contactName": ""
    }
    if(data.clientStatementName &&  data.clientStartDate && data.frequencyId && data.batchNumId && data.reviewerId )
    {
     
      if(data.contactId>0 || data.taxEntityId>0)
      {
        sbaAxios({url:insertUpdateCSAPI,method:'post', data:data}).then(res=>{
          if(res==-1)
          {
            SBNotify({Msg:"Selected Account Already Mapped" ,type:"error"});
          }
          else if(res==-2)
          {
            SBNotify({Msg:"Selected Contact Already Mapped" ,type:"error"});
          }
          else {
          SBNotify({Msg:"Client Statement Updated Successfully"});
          setDrawer(false);
          setRender(value=>!value);
          }
        }).catch(e=>{
          console.log(e,"Error Updating the selected Client Statment")
        });
      }
      else{
      SBNotify({Msg:"Please Enter All the Mandatory Fields" ,type:"error"});
      }
     
    }
    else{
      SBNotify({Msg:"Please Enter All the Mandatory Fields" ,type:"error"});
    }
  };
  return <>
      <div className={"mb-4"}>
            <span>
                Client Statement Name
                <span class="mandatory">*</span>
            </span>
            <div >
                <input
                    className="form-control w-75"
                    value={cs?.ClientStatementName}
                    type={"text"}
                    onChange={(e) => { setCS(value=>({...value, 'ClientStatementName':e?.target?.value || ""})) }}
                />
            </div>
      </div>
      <div className={"mb-4"}>
            <span className="d-block">
                Entity Type
                <span class="mandatory">*</span>
            </span>
            <input type="radio" name="entity" checked={cs?.ContactId !=0}  onChange={(e)=>{setCS(value=>({...value,'TaxEntityName':"",'TaxEntityId':0,'ContactName':null,'ContactId':-1}))}}/> <span className="mx-1">Contact</span>
            <input type="radio" name="entity"  checked={cs?.TaxEntityId !=0} onChange={(e)=>{setCS(value=>({...value,'TaxEntityName':null,'TaxEntityId':-1,'ContactName':'','ContactId':0}))}} /> <span className="mx-1">Account</span>
      </div>
      {cs?.ContactId !=0 && <>
      <div className={"mb-4"}>
            <span>
                Contact
                <span class="mandatory">*</span>
            </span>
            <SBAComboBox placeholder="Please Select" value={{EntityName:cs?.ContactName,EntityId:cs?.ContactId}}   popupSettings={{ className: 'modalDD' }} data={contactList} textField="EntityName" valueField="EntityId" onChange={(e)=>{if(e.value){const {EntityId,EntityName}=e.value; {setCS(value=>({...value,'ContactName':EntityName,'ContactId':EntityId,'TaxEntityName':null,'TaxEntityId':0}))}}}}/>
      </div>
      </>
      }
     {cs?.TaxEntityId!=0 && <>
      <div className={"mb-4"}>
            <span>
                Account
                <span class="mandatory">*</span>
            </span>
            <SBAComboBox placeholder="Please Select" value={{EntityId:cs?.TaxEntityId,EntityName:cs?.TaxEntityName}}  popupSettings={{ className: 'modalDD' }} data={accountList} textField="EntityName" valueField="EntityId" onChange={(e)=>{if(e.value){const {EntityId,EntityName}=e.value; {setCS(value=>({...value,'TaxEntityName':EntityName,'TaxEntityId':EntityId,'ContactName':null,'ContactId':0})) }}}}/>
      </div>
     
     </>} 
      <div className={"mb-4"}>
            <span>
                Start Date
                <span class="mandatory">*</span>
            </span>
            <div >
               <SBDatePicker  value={moment(cs?.ClientStartDate || null)} onChange={(e) => { setCS(value=>({...value,'ClientStartDate':e?.toISOString()})) }}/>
            </div>
      </div>
      <div className={"mb-4"}>
            <span>
                Frequency
                <span class="mandatory">*</span>
            </span>
           <SBAComboBox value={{EnumName:cs?.FrequencyName,EnumValue:cs?.FrequencyId}}    popupSettings={{ className: 'modalDD' }} data={frequencyDs} textField="EnumName" valueField="EnumValue" onChange={(e)=>{if(e.value){const {EnumName,EnumValue}=e.value; {setCS(value=>({...value,'FrequencyName':EnumName,'FrequencyId':EnumValue}))}}}}/>
      </div>
      <div className={"mb-4"}>
            <span>
                Batch
                <span class="mandatory">*</span>
            </span>
            <SBAComboBox value={{EnumName:cs?.BatchNumName,EnumValue:cs?.BatchNumId}}     popupSettings={{ className: 'modalDD' }} data={batchDs} textField="EnumName" valueField="EnumValue" onChange={(e)=>{if(e.value){const {EnumName,EnumValue}=e.value; {setCS(value=>({...value,'BatchNumName':EnumName,'BatchNumId':EnumValue}))}}}}/>
      </div>
      <div className={"mb-4"}>
            <span>
                Reviewer
                <span class="mandatory">*</span>
            </span>
            <SBAComboBox value={{Fullname:cs?.ReviewerName,UserId:cs?.ReviewerId}}     popupSettings={{ className: 'modalDD' }} data={reviewerDs} textField="Fullname" valueField="UserId" onChange={(e)=>{if(e.value){const {Fullname,UserId}=e.value; {setCS(value=>({...value,'ReviewerName':Fullname,'ReviewerId':UserId}))}}}}/>
      </div>
      <div className={"mb-4"}>
            <span>
            <input
                    className="me-2"
                    checked={cs?.InternalOnly ||false}
                    type={"checkbox"}
                    onChange={(e) => { setCS(value=>({...value, 'InternalOnly':e?.target?.checked || false})) }}
                />
                Internal
            </span>
      </div>
      <div className={"mb-4"}>
            <span>
            <input
                    className="me-2"
                    checked={cs?.IncludeInComposite || false}
                    type={"checkbox"}
                    onChange={(e) => { setCS(value=>({...value, 'IncludeInComposite':e?.target?.checked || false})) }}
                />
                Incomposite
            </span>
      </div>
      <div className={"mb-4"}>
            <span>
            <input
                    className="me-2"
                    checked={cs?.DoNotAutomate || false}
                    type={"checkbox"}
                    onChange={(e) => { setCS(value=>({...value, 'DoNotAutomate':e?.target?.checked || false})) }}
                />
                Do Not Automate
            </span>
      </div>
      <div className={"mb-4"}>
            <span>
                Notes
            </span>
            <div >
                <textarea
                    className="form-control w-75"
                    value={cs?.Notes}
                    onChange={(e) => { setCS(value=>({...value,'Notes':e?.target?.value || ''})) }}
                />
            </div>
      </div>
      <div className="d-flex ">
            <button className="s-sm-btn mx-1" onClick={() => { setDrawer(false) }} >Cancel</button>
            <button className="p-sm-btn mx-1" onClick={() => { updateOrInsertCS()}} disabled={false}> {operation}</button>
        </div>
  </> 
};
const PortfolioEditor = ({ ClientStatement,setDrawer, setRender }) => {
  const entityTypeDS=[
    {id:2,Value:"Portfolio"},
    {id:52,Value:"Partnership"},
    {id:53,Value:"Legacy Portfolio"}
  ];
  const [selectedEntityType,setSelectedEntityType]=useState(entityTypeDS[0]);
  const [entitiesDS,setEntitiesDS]=useState([]);
  const [selectedEntity,setSeletectedEntity ]=useState(null);

  const entityTypeDDChange=(e)=>{
    if(e.value)
    {
      setSelectedEntityType(e.value)
      setEntitiesDS([]);
      setSeletectedEntity(null)
    }
  };
  const getEntities=async(csID,entityTypeId,entityName)=>{
    sbaAxios({url:`${getEntitesCSAPI}${csID},${entityTypeId},${entityName}`}).then(res=>{
      setEntitiesDS(res)
    }).catch(
      setEntitiesDS([])
    )
  }
  const entitiesDDFilterChange=(e)=>{
    const string=e.filter.value;
    if(selectedEntityType.id && ClientStatement.ClientStatementId && string)
    getEntities(ClientStatement.ClientStatementId,selectedEntityType.id,string);
  };
  const entityDDChange=(e)=>{
    if(e.value)
    {
      setSeletectedEntity(e.value)
    }
  };
  const updatePortfolio=()=>{
    if(selectedEntity?.EntityId && selectedEntityType?.id && ClientStatement?.ClientStatementId )
    sbaAxios({url:`${saveCSLinkedPortfolio}${ClientStatement.ClientStatementId},${selectedEntityType.id},${selectedEntity.EntityId}`, method:'post'}).then(
      res=>{
        SBNotify({Msg:`Portfolio Linked with Client Statemnet Successfully`});
        setRender(value=>!value);
        setDrawer(false)
      }
    ).catch(e=>{
      SBNotify({Msg:`Portfolio Linked with Client Statemnet Successfully` , type:"error"});
    })
    else {
      SBNotify({Msg:`Please Select All the Fields` , type:"error"});
    }
  }
  return <> <div className={"mb-4"}>
    <span>
      Entity Type
    </span>
    <div >
      <SBADropDown data={entityTypeDS}  popupSettings={{ className: 'modalDD' }} value={selectedEntityType} onChange={entityTypeDDChange} textField="Value" valueField="id"/>
    </div>
  </div>
    <div className={"mb-4"}>
      <span>
        Entity 
      </span>
      <div >
        <SBAComboBox data={entitiesDS}  popupSettings={{ className: 'modalDD' }} value={selectedEntity}  onChange={entityDDChange} textField="EntityName" valueField="EntityId" onFilterChange={entitiesDDFilterChange} />
      </div>
    </div>
    <div className="d-flex ">
            <button className="s-sm-btn mx-1" onClick={() => { setDrawer(false) }} >Cancel</button>
            <button className="p-sm-btn mx-1" onClick={() => { updatePortfolio()}} disabled={false}> {"Add"}</button>
        </div>
    </>
};
const getDateString = (e) => {
  return moment(e?.value).format('MM-DD-YYYY');
};
const nulledCS = {
  "ClientStatementId": 0,
  "ClientStatementName": "",
  "ClientStartDate": "",
  "FrequencyId": 0,
  "FrequencyName": "",
  "BatchNumId": 0,
  "BatchNumName": "",
  "ReviewerId": 0,
  "ReviewerName": "",
  "InternalOnly": false,
  "IncludeInComposite": false,
  "DoNotAutomate": false,
  "Notes": "",
  "TaxEntityId": 0,
  "TaxEntityName": "N/A",
  "ContactId": -1,
  "ContactName": "Please Select"
};
const ClientStatementDeleteModal=({showModal,closeModal,clientStatement,linkedPortfolio,setRender,setUpdatePortfolioGrid,setCS})=>{
  const deleteClientStatement=()=>{
    const id=clientStatement.ClientStatementId;
    sbaAxios({url:`${deleteCSAPI}${id}`,method:"post"}).then(res=>{
        SBNotify({Msg:"Selected Client Statement Deleted Successfully"});
        closeModal(false);
        setUpdatePortfolioGrid(value=>!value);
        setRender(value=>!value);
        setCS(null);
      }).catch(e=>{
        closeModal(false);
    });
  }
return  <Modal show={showModal} onHide={()=>{closeModal(false)}}>
<Modal.Header closeButton>
  <Modal.Title>Do you want to delete the Selected Client Statement?</Modal.Title>
</Modal.Header>
<Modal.Body>
  <p>
    Are you sure? you want to delete
    permanently.
  </p>
 
  {linkedPortfolio.length>0 &&  <p>Selected  Client Statement has Portfolio linked</p>}
 
</Modal.Body>
<Modal.Footer>
  <button className="s-sm-btn mx-1" onClick={()=>{closeModal(false)}}>
    Cancel
  </button>
  <button className="p-sm-btn mx-1" onClick={deleteClientStatement}>
    Delete
  </button>
</Modal.Footer>
</Modal>
}
const PortfolioDeleteModal=({showModal,closeModal,Portfolio,setRender})=>{
  const deletePortfolio=()=>{
    const id=Portfolio.ClientStatementMappingId;
    sbaAxios({url:`${deleteCSPortfolioAPI}${id}` , method:'post'}).then(res=>{
        SBNotify({Msg:"Selected Portfolio Deleted Successfully"});
        closeModal(false);
        setRender(value=>!value);
      }).catch(e=>{
        closeModal(false);
    });
  }
return  <Modal show={showModal} onHide={()=>{closeModal(false)}}>
<Modal.Header closeButton>
  <Modal.Title>Do you want to delete the Selected Portfolio?</Modal.Title>
</Modal.Header>
<Modal.Body>
  <p>
    Are you sure? you want to delete
    permanently.
  </p>
</Modal.Body>
<Modal.Footer>
  <button className="s-sm-btn mx-1" onClick={()=>{closeModal(false)}}>
    Cancel
  </button>
  <button className="p-sm-btn mx-1" onClick={deletePortfolio}>
    Delete
  </button>
</Modal.Footer>
</Modal>
}